// Version configuration for the application
// This file is used to maintain a single source of truth for version information

// Priority order for version:
// 1. Environment variable (APP_VERSION)
// 2. Package.json version
// 3. Fallback hardcoded version

const getVersionFromPackageJson = (): string | undefined => {
  try {
    // In build time, we can access package.json
    const packageJson = require('../../package.json');
    return packageJson.version;
  } catch (error) {
    // In runtime, package.json might not be available
    console.warn(
      'Could not read version from package.json, using fallback version',
    );
    return undefined;
  }
};

export const APP_VERSION = getVersionFromPackageJson();

// You can also add other version-related constants here
export const BUILD_TIME = new Date().toISOString();

// Export version info for debugging
export const VERSION_INFO = {
  version: APP_VERSION,
  buildTime: BUILD_TIME,
  environment: process.env.NODE_ENV || 'development',
  umiEnv: process.env.UMI_ENV || 'unknown',
};

// Log version info in development
if (process.env.NODE_ENV === 'development') {
  console.log('App Version Info:', VERSION_INFO);
}
